import React, { useContext, useEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';

import { AnswerContext } from '../../index';
import { Container } from './styles';

function StepThree() {
  const yesBtn = useRef();
  const notBtn = useRef();
  const { state, dispatch, WizardContext } = useContext(AnswerContext);
  const { dispatch: wizardDispatch } = useContext(WizardContext);

  function setRequired(required) {
    dispatch({ type: 'SET_REQUIRED', required: required });
    wizardDispatch({ type: 'NEXT_STEP' });
  }

  useEffect(() => {
    wizardDispatch({
      type: 'SET_IS_COMPLETE',
      isComplete: state.required === null ? false : true,
    });
  }, [state]);

  function handleKeyUp(event) {
    if (event.key === 'ArrowRight') {
      return notBtn.current.focus();
    }

    if (event.key === 'ArrowLeft') {
      return yesBtn.current.focus();
    }

    if (event.key === 'Enter') {
      if (state.required === undefined) return;
      wizardDispatch({ type: 'NEXT_STEP' });
    }
  }

  return (
    <div>
      <Button
        onClick={() => setRequired(true)}
        onKeyUp={handleKeyUp}
        variant='contained'
        autoFocus
        ref={yesBtn}
        color={state.required === true ? 'primary' : 'default'}>
        Sim
      </Button>
      <Button
        onClick={() => setRequired(false)}
        onKeyUp={handleKeyUp}
        ref={notBtn}
        style={{ marginLeft: '10px' }}
        color={state.required === false ? 'primary' : 'default'}
        variant='contained'>
        Não
      </Button>
    </div>
  );
}

export default StepThree;
